export default {
  STORAGE_ACCESS_TOKEN: 'auth-access-token',
};
